export default {
  'delegatedTasks.title': 'Gestionar Tareas Delegadas',

  'delegatedTasks.form.status': 'Estado',
  'delegatedTasks.form.process': 'Proceso',
  'delegatedTasks.form.environment': 'Entorno',
  'delegatedTasks.form.processInstanceName': 'Nombre Solicitud',
  'delegatedTasks.form.name': 'Usuario delegado',
  'delegatedTasks.form.actionInstanceId': 'Paso de Ejecución',
  'delegatedTasks.form.created': 'Fecha de creación',

  'delegatedTasks.delegated': 'Delegado',
  'delegatedTasks.deleted': 'Removido',
};
